
const GetVeridionKpiReducer = (state = { type: 'LOADING_VERIDION__DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_VERIDION_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}

export {
    GetVeridionKpiReducer
}